export default __webpack_public_path__ + "static/media/Bracers of the Ubah Kan.f1637a2a.jpg";